import React, { useRef, useState } from "react";
import "flowbite";
import PhoneInput from "react-phone-number-input";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Paymentmethod from "./Paymentmethod";
import Verifylogin from "./Verifylogin";
import Loading from "./Loading";

const Login = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);


  const openModal = () => {
    showModal ? setShowModal(false) : setShowModal(true);
  };

  const openVerifyModal = () => {
    showVerifyModal ? setShowVerifyModal(false) : setShowVerifyModal(true);
  };
  // const [phoneno, setPhoneno] = useState();
  const [email, setEmail] = useState();
  const submitUserDetails = async () => {
    setIsLoading(true)
    try { 
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/email-otp`,
        { email: email }
      );
      if (res.data.success) {
        setIsLoading(false)
        console.log("Successfuly ", res.data.OTP);

        toast("Success Use this OTP : " + res?.data?.OTP, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // alert("Success Use this OTP : "+res?.data?.OTP)
        localStorage.setItem("email", email);
        localStorage.setItem("check", "email");
      } else {
        setIsLoading(false);
        console.log("error ", res.data.msg);

        toast(res.data.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        // alert(res.data.msg)
      }
    } catch (error) {
      setIsLoading(false)
      console.error("Error logging in:", error);

      toast(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      // alert(error);
    }
    setIsLoading(false)
  };

  return (
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >

        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2">
                <div className="sm:flex sm:items-start">
                  <div className="p-2">
                    <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                      Sign in to our platform
                    </h3>

                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                      >
                        Enter Email
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setEmail(e.target.value)}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Email"
                        required
                      />
                    </div>

                    <button
                      // data-modal-target="loginverification-modal"
                      // data-modal-toggle="loginverification-modal"
                      data-modal-hide="email-modal"
                      disabled={!email}
                      onClick={() => {
                        submitUserDetails().then(() => {
                          openVerifyModal();
                        });
                      }}
                      className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Submit
                    </button>
                    <div className="flex gap-1">
                      <h1 className="text-white">Not Registered Yet?</h1>
                      <h1
                        className="text-white hover:cursor-pointer"
                        onClick={openModal}

                        // data-modal-target="authentication-modal"
                        // data-modal-toggle="authentication-modal"
                        // data-modal-hide="email-modal"
                      >
                        Sign Up
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={props.modalLoginClose}
                type="button"
                className="mx-4 my-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "

              >
                Cancel
              </button>
            </div>
          </div>
        </div>

      {showModal ? <Paymentmethod modalClose={() => {openModal(); props.modalLoginClose()}} /> : ""}
      {showVerifyModal ? (
        <Verifylogin modalVerifyClose={() => {openVerifyModal();props.modalLoginClose()}} />
        ) : (
          ""
          )}

      <Loading isLoading={isLoading} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        />
  </div>
  );
};

export default Login;
